import { useNavigate } from "react-router-dom";
import { AlertOctagon } from "lucide-react";
import { Panel } from "@/components/common";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate, money, todayISO } from "@/lib/format";

export const OverdueInvoices = () => {
  const navigate = useNavigate();
  const { data } = useFetch("/invoices");
  const today = todayISO();
  const overdue = (data || []).filter((i) => i.status !== "Paid" && i.due_date < today);
  const unpaid = (data || []).filter((i) => i.status !== "Paid");
  return (
    <Panel title={<span className="inline-flex items-center gap-2"><AlertOctagon className="h-4 w-4 text-rose-600" /> Overdue invoices ({overdue.length}) · {money(overdue.reduce((s, i) => s + i.subtotal, 0))}</span>}
      action={<span className="text-xs text-slate-500">{unpaid.length} unpaid in total</span>}>
      {overdue.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="overdue-empty">No overdue company invoices.</p>
      ) : (
        <ul className="divide-y divide-slate-100" data-testid="overdue-list">
          {overdue.slice(0, 10).map((i) => (
            <li key={i.id} onClick={() => navigate(`/invoices/${i.id}`)} className="flex cursor-pointer flex-wrap items-center gap-x-4 gap-y-1 py-2.5 hover:bg-rose-50/60" data-testid={`overdue-${i.id}`}>
              <span className="font-mono text-xs font-bold text-[#0E1E38]">{i.invoice_number}</span>
              <span className="min-w-[120px] font-medium">{i.company}</span>
              <span className="text-sm text-slate-500">{i.status} · due {fmtDate(i.due_date, "d MMM")}</span>
              <span className="ml-auto rounded bg-rose-100 px-2 py-0.5 font-mono text-xs font-semibold text-rose-800">{money(i.subtotal)} · {Math.round((new Date(today) - new Date(i.due_date)) / 86400000)}d late</span>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
};
